import { ProgressBar } from '@lbcamden/lib-react';
import { FunctionComponent, useEffect, useState } from 'react';
import { useInterval } from 'usehooks-ts';

import { InitialSyncProgress, useTinybaseStore } from '~/client/store/tinybase/tinybaseStore';

type Props = {
  hasStarted?: boolean;
  hasCompleted?: boolean;
};

const maxPreCompletePercent = 95;
const incrementIntervalMs = 300;

/** Amounts should add up to the maxPreCompletePercent value */
const stepProgressAmounts: Record<keyof InitialSyncProgress, number> = {
  globalStoreInit: 30,
  userStoreInit: 30,
  syncStarted: 35,
};

export const DataSyncProgress: FunctionComponent<Props> = ({ hasStarted, hasCompleted }) => {
  const initialSyncProgress = useTinybaseStore((state) => state.initialSyncProgress);

  const [progress, setProgress] = useState(0);

  const intervalActive = hasStarted && progress < maxPreCompletePercent;

  const onInitialSyncProgressUpdated = () => {
    const completedSteps = (
      Object.keys(initialSyncProgress) as (keyof InitialSyncProgress)[]
    ).filter((step) => initialSyncProgress[step]);

    const newProgressValue = completedSteps.reduce(
      (total, step) => total + stepProgressAmounts[step],
      0,
    );
    const cappedProgressValue = Math.min(newProgressValue, maxPreCompletePercent);

    setProgress((current) => Math.max(current, cappedProgressValue));
  };

  useInterval(
    () => {
      setProgress((current) => current + 1);
    },
    intervalActive ? incrementIntervalMs : null,
  );

  useEffect(onInitialSyncProgressUpdated, [initialSyncProgress]);

  return <ProgressBar progress={hasCompleted ? 100 : progress} />;
};
